import {useBrand} from '@/contexts/BrandContext';
import {LogoGreyCircle} from '@ark/web';
import {BoxProps} from '@mui/material';

export const BrandLogoCircle = (props: BoxProps) => {
  const {key, name, assets} = useBrand();
  if (key === 'ark') return <LogoGreyCircle {...props} />;
  return <LogoGreyCircle logoSrc={assets.symbol} logoAlt={name} {...props} />;
};
